var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about-page"},[_c('headerView',{attrs:{"seletedindex":_vm.seletedindex}}),_c('div',{staticClass:"banner",style:({
      backgroundImage:
        'url(' +
        _vm.aboutUsBanner.imgUrl +
        ')',
    })}),_c('div',{staticClass:"new_details_content"},[_c('div',{staticClass:"container",domProps:{"innerHTML":_vm._s(_vm.AboutUsContent)}})]),_c('footerView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }